export default __webpack_public_path__ + "static/media/pipeline-icon.37190936.svg";